/**
 * Client version advertised to the API via the `x-app-version` header, in the
 * API's `<platform>-<major>.<minor>.<patch>` format. `w` = web dashboard.
 *
 * The API serves legacy response shapes (e.g. merchant `type` as a bare string
 * instead of the full type object) to clients that do not send this header, so
 * the dashboard must send it on endpoints whose shape it depends on. The
 * version is pinned high on purpose: the dashboard deploys together with the
 * API and always wants the newest shape, so it must sit above every legacy
 * version gate.
 */
export const APP_VERSION_HEADER = "w-9.9.9";

export enum PermissionRole {
  Admin = "ADMIN",
  Staff = "STAFF"
}
